/**
 * Role reads for the client, mirroring server/src/utils/roles.js.
 *
 * The server is the authority and refuses every call these would hide; the
 * client repeats the rules only so a coordinator sees the controls they can
 * use rather than a page of refusals. A coordinator's institution is their
 * own profile's, and a profile holding both roles acts as an admin.
 */

export const hasRole = (profile, role) => (profile?.roles || []).includes(role);

export const isAdmin = (profile) => hasRole(profile, 'admin');

/** The institution a non-admin coordinator is scoped to, or null. */
export function coordinatedInstitution(profile) {
    if (isAdmin(profile) || !hasRole(profile, 'coordinator')) {
        return null;
    }
    return profile.institution || null;
}

/** Whether a profile holds any of `roles`, with the admin bypass. */
export const hasAnyRole = (profile, roles) =>
    isAdmin(profile) || roles.some((role) => hasRole(profile, role));
